import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useWebSocket } from "../../contexts/WebSocketContext"; // 👈 اضافه شد
import Tornoment from "./tornoments/Tornoment";
import OperatorComponent from "../operator/OperatorComponent";
import AccountConfig from "./accountconfig/AccountConfig";
import QuestionsCrud from "./QuestionsCrud";
import Teams from "./teams/Teams";
import TransferMarket from "./transfermarket/TransferMarket";
import ChangeCapitan from "./ChangeCapitan/ChangeCapitan";
import OperatorMultiTVComponent from "../operator/OperatorMultiTvComponent";
import AddPoints from "./addpoint/AddPoints";
import Finalists from "./Finalists";

function SupportDashboard() {
  const [activeTab, setActiveTab] = useState("tickets");
  const { user, logout } = useAuth();

  // 👇 استفاده از WebSocket Context به جای WebSocket داخلی
  const { isSocketConnected, socketData } = useWebSocket();

  const sidebarItems = [
    { id: "tournoments", label: "تورنومنت ها", icon: "🎫" },
    { id: "finalists", label: "فینالیست ها", icon: "🎫" },
    { id: "operator", label: "اوپراتور", icon: "💬" },
    { id: "tvOperator", label: "اوپراتور تلویزیون", icon: "💬" },
    { id: "account-config", label: "تنظیمات حساب ها", icon: "💬" },
    { id: "questions", label: "سوالات مرحله 2", icon: "💬" },
    { id: "teams", label: "تیم ها", icon: "📊" },
    { id: "Transfer", label: "ترنسفر مارکت", icon: "📊" },
    { id: "change-capitan", label: "درخواست های تغییر کاپیتان", icon: "💬" },
      { id: "addpoints", label: "اضافه کردن امتیاز دستی", icon: "💬" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "tournoments":
        return <Tornoment />;
      case "operator":
        return <OperatorComponent socketData={socketData || {}} />;
      case "account-config":
        return <AccountConfig />;
      case "questions":
        return <QuestionsCrud />;
      case "teams":
        return <Teams />;
      case "Transfer":
        return <TransferMarket />;
      case "change-capitan":
        return <ChangeCapitan />;
      case "tvOperator":
        return <OperatorMultiTVComponent />;
        case "addpoints":
        return <AddPoints />;
         case "finalists":
        return <Finalists />;
      default:
        return null;
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ direction: "rtl", backgroundColor: "#1f2937" }}
    >
      {/* Header */}
      <header
        className="shadow-lg border-b border-gray-700 z-10"
        style={{ backgroundColor: "#111827" }}
      >
        <div className="px-8 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center ml-4"
              style={{ backgroundColor: "#10b981" }}
            >
              <span className="text-white text-xl">
                {sidebarItems.find((item) => item.id === activeTab)?.icon}
              </span>
            </div>
            <h1 className="text-xl font-semibold text-white">
              {sidebarItems.find((item) => item.id === activeTab)?.label}
            </h1>
          </div>

          <div className="flex items-center gap-4">
            {/* نمایش وضعیت اتصال Socket */}
            <div className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{
                  backgroundColor: isSocketConnected ? "#10b981" : "#ef4444",
                  boxShadow: isSocketConnected
                    ? "0 0 8px rgba(16, 185, 129, 0.6)"
                    : "0 0 8px rgba(239, 68, 68, 0.6)",
                }}
              />
              <span className="text-xs text-gray-400">
                {isSocketConnected ? "متصل" : "قطع"}
              </span>
            </div>

            <div className="flex items-center gap-3">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center"
                style={{ backgroundColor: "#10b981" }}
              >
                <span className="text-white text-sm font-medium">
                  {user.username?.charAt(0)?.toUpperCase() || "S"}
                </span>
              </div>
              <span className="text-gray-300 font-medium">{user.username}</span>
              <div
                className="px-2 py-1 text-xs rounded-full border"
                style={{
                  backgroundColor: "#065f46",
                  borderColor: "#10b981",
                  color: "#10b981",
                }}
              >
                پشتیبان
              </div>
            </div>

            <button
              onClick={() => logout()}
              className="px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition duration-200 flex items-center gap-2"
            >
              <span>خروج</span>
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
            </button>
          </div>
        </div>
      </header>

      <div className="flex flex-1">
        {/* Sidebar */}
        <div
          className="w-64 shadow-xl border-l border-gray-700"
          style={{ backgroundColor: "#111827" }}
        >
          <div className="p-6 border-b border-gray-700">
            <h2 className="text-lg font-semibold text-white text-center">
              پنل پشتیبانی
            </h2>
          </div>

          <nav className="p-4">
            {sidebarItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center px-4 py-3 rounded-xl transition duration-200 mb-2 ${
                  activeTab === item.id
                    ? "text-white shadow-sm"
                    : "text-gray-300 hover:text-white"
                }`}
                style={{
                  backgroundColor:
                    activeTab === item.id ? "#1f2937" : "transparent",
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== item.id) {
                    e.target.style.backgroundColor = "#374151";
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== item.id) {
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center ml-3`}
                  style={{
                    backgroundColor:
                      activeTab === item.id ? "#10b981" : "#374151",
                  }}
                >
                  <span className="text-lg">{item.icon}</span>
                </div>
                <span className="font-medium">{item.label}</span>
                {item.id === "tickets" && (
                  <div
                    className="mr-auto w-5 h-5 rounded-full text-xs flex items-center justify-center"
                    style={{ backgroundColor: "#10b981", color: "white" }}
                  >
                    3
                  </div>
                )}
              </button>
            ))}
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-6">
          <div
            className="rounded-2xl shadow-sm border border-gray-600 h-full"
            style={{ backgroundColor: "#111827" }}
          >
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportDashboard;